import React, { useEffect } from 'react';

/**
 * Single product theme wrapper (Shopify B&W, light-only).
 * Use on Admin + Vendor layouts and logged-in client product pages.
 */
const ProductShell = ({ children, className = '' }) => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    try {
      localStorage.removeItem('admin-dashboard-theme');
      localStorage.removeItem('vendor-dashboard-theme');
    } catch {
      /* ignore */
    }
  }, []);

  return (
    <div className={`product-app theme-vendalist dashboard-app ${className}`.trim()}>
      {children}
    </div>
  );
};

export default ProductShell;
